import { useAppDispatch, useAppSelector } from 'hooks';
import { FC } from 'react';
import { selectAutoFilledData, selectJobNotes, updateJobNotes } from '../createJobSlice';
import { CustomTextArea } from 'components';
import { VoidFn } from 'types/baseTypes';
import AutoFilledIndicator from 'components/auto-filled-indicator/AutoFilledIndicator';
import { notesMaxCount } from 'containers/settings/constants';

interface JobNotesSectionProps {
  className?: string;
  handleOnFocus: VoidFn;
}

const JobNotesSection: FC<JobNotesSectionProps> = ({ className, handleOnFocus }) => {
  const selectedJobNotes = useAppSelector(selectJobNotes);
  const autoFilledData = useAppSelector(selectAutoFilledData);

  const dispatch = useAppDispatch();

  const handleNoteChange = value => {
    dispatch(updateJobNotes(value));
  };

  return (
    <div className={className}>
      <div className="mb-2 text-17px font-semibold text-heading">
        Notes{' '}
        <AutoFilledIndicator
          isAutoFilled={autoFilledData?.note?.comment && autoFilledData?.note?.comment === selectedJobNotes}
        />
      </div>
      <div>
        <CustomTextArea
          resizeTextArea={true}
          id="create-job-notes"
          maxLength={notesMaxCount}
          name="notes"
          placeholder="Enter notes here"
          value={selectedJobNotes ?? ''}
          onChange={handleNoteChange}
          className="mb-4 py-[15px]"
          onFocus={handleOnFocus}
        />
      </div>
    </div>
  );
};

export default JobNotesSection;
